import { useLayoutEffect, useState } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import Loader from "@/shared/ui/Loader";
import { VehiclesTab } from "@/domains/estate/constants/vehiclesTab";
import { vehiclesSelectedTabSelector } from "@/domains/estate/slice";
import useVehicles from "@/domains/estate/hooks/useVehicles";
import EstateVehiclesAddContainer from "@/domains/estate/containers/tablet/tabs/vehicles/EstateVehiclesAddContainer";
import EstateVehiclesList from "@/domains/estate/components/vehicles/EstateVehiclesList";

export default function EstateVehiclesListContainer({
  onSelectVehicleId,
}: {
  onSelectVehicleId: (id: number) => void;
}) {
  const [index, setIndex] = useState<number | null>(null);
  const selectedTab = useAppSelector(vehiclesSelectedTabSelector);
  const { vehicles, loadVehicles, loading, resetting, parkingReset } = useVehicles();

  const filteredVehicles = vehicles.filter((vehicle) => {
    if (!vehicle) {
      return true;
    }

    switch (selectedTab) {
      case VehiclesTab.Owner: {
        return vehicle.relation.isOwner;
      }

      case VehiclesTab.Shared: {
        return vehicle.relation.isShared;
      }

      default: {
        return true;
      }
    }
  });

  useLayoutEffect(() => {
    loadVehicles();
  }, [loadVehicles]);

  return (
    <>
      <EstateVehiclesAddContainer
        index={index}
        open={index !== null}
        onClose={() => {
          loadVehicles();
          setIndex(null);
        }}
      />
      {loading || resetting ? (
        <Loader />
      ) : (
        <EstateVehiclesList
          vehicles={filteredVehicles}
          onSelectVehicleId={onSelectVehicleId}
          onResetParking={(vehicleId) => {
            parkingReset(vehicleId).then(() => {
              loadVehicles();
            });
          }}
          onAddVehicle={(i) => setIndex(i)}
        />
      )}
    </>
  );
}
